var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"grid-row",class:[ 'mb-'+ _vm.mb, 'mt-'+ _vm.mt, _vm.type, _vm.wrap, _vm.setXlsCols, _vm.setXsCols, _vm.setXlCols, _vm.setLgCols, _vm.setMdCols, _vm.setSmCols,  _vm.setCols ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }